function formatDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("es-ES", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

function fmtMoney(n) {
  if (n == null || n === "") return "—";
  return `${Number(n).toLocaleString("es-ES", { minimumFractionDigits: 2 })} €`;
}

function ServiceTable({ label, services }) {
  if (!Array.isArray(services) || services.length === 0) return null;

  return (
    <div>
      <p className="text-xs font-medium text-gray-500 mb-2">{label}</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-gray-400 uppercase">
              <th className="pb-1 pr-4">Nombre</th>
              <th className="pb-1 pr-4">Cuota</th>
              <th className="pb-1 pr-4">Min</th>
              <th className="pb-1 pr-4">Ses/sem</th>
              {services[0]?.personas != null && (
                <th className="pb-1 pr-4">Personas</th>
              )}
            </tr>
          </thead>
          <tbody>
            {services.map((s, i) => (
              <tr key={i}>
                <td className="py-0.5 pr-4 text-gray-700">
                  {s.nombre || `Servicio ${i + 1}`}
                </td>
                <td className="py-0.5 pr-4 font-medium">
                  {fmtMoney(s.cuota)}
                </td>
                <td className="py-0.5 pr-4 text-gray-600">
                  {s.minutos || "—"}
                </td>
                <td className="py-0.5 pr-4 text-gray-600">
                  {s.sesiones_semana ?? "—"}
                </td>
                {s.personas != null && (
                  <td className="py-0.5 pr-4 text-gray-600">{s.personas}</td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function EmployeeTable({ employees }) {
  if (!Array.isArray(employees) || employees.length === 0) return null;

  return (
    <div>
      <p className="text-xs font-medium text-gray-500 mb-2">Empleados</p>
      <div className="space-y-1">
        {employees.map((e, i) => (
          <div key={i} className="flex justify-between text-sm">
            <span className="text-gray-700">{e.nombre || `Empleado ${i + 1}`}</span>
            <span className="text-gray-500">
              {e.horas}h/sem · {fmtMoney(e.salario)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function ExpenseTable({ expenses }) {
  if (!Array.isArray(expenses) || expenses.length === 0) return null;

  const withAmount = expenses.filter((g) => g.importe !== "" && g.importe != null);
  if (withAmount.length === 0) return null;

  return (
    <div>
      <p className="text-xs font-medium text-gray-500 mb-2">Gastos</p>
      <div className="space-y-1">
        {withAmount.map((g, i) => (
          <div key={i} className="flex justify-between text-sm">
            <span className="text-gray-700">
              {g.concepto}
              <span className="ml-1 text-xs text-gray-400">({g.tipo})</span>
            </span>
            <span className="font-medium">{fmtMoney(g.importe)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function SimulationsTab({ simulations }) {
  if (simulations.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-400">
          Este alumno no tiene simulaciones creadas
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <p className="text-sm text-gray-500">
        {simulations.length} simulaci{simulations.length !== 1 ? "ones" : "ón"}
      </p>

      <div className="space-y-3">
        {simulations.map((sim) => (
          <details
            key={sim.id}
            className="bg-white rounded-xl border border-gray-200 overflow-hidden group"
          >
            <summary className="px-4 py-3 flex justify-between items-center cursor-pointer hover:bg-gray-50">
              <div>
                <span className="font-medium text-gray-900">
                  {sim.name || "Sin nombre"}
                </span>
                <span className="ml-2 text-xs text-gray-400">
                  {formatDate(sim.created_at)}
                </span>
              </div>
            </summary>
            <div className="px-4 pb-4 space-y-4 border-t border-gray-100 pt-3">
              <ServiceTable
                label="Servicios de grupo"
                services={sim.servicios_grupo}
              />
              <ServiceTable
                label="Servicios individuales"
                services={sim.servicios_individuales}
              />
              <EmployeeTable employees={sim.empleados} />
              <ExpenseTable expenses={sim.gastos} />
            </div>
          </details>
        ))}
      </div>
    </div>
  );
}
